import { memo } from 'react'
import { SxProps } from '@mui/material'
import { Box } from '@/components/Layout'
import { Button } from '@/components/Inputs'
import { currencyModalStyles as styles } from '../CurrencyModal.style'
import { useCurrencyOptionController } from './CurrencyOption.controller'
import { CurrencyOptionProps } from './CurrencyOption.types'

function CurrencyOption(props: CurrencyOptionProps) {
  const { option, isSelected } = props
  const { onSelectClick } = useCurrencyOptionController(props)

  return (
    <Button
      fullWidth
      size="small"
      variant="contained"
      color="secondary"
      onClick={onSelectClick}
      aria-pressed={isSelected}
      sx={[styles.currencyButton, isSelected && styles.currencyButtonActive] as SxProps}
      startIcon={<Box component={option.flag} sx={styles.currencyIcon} />}>
      {option.code}
    </Button>
  )
}

export default memo(CurrencyOption)
